import { injectReducer } from '../../../../../store/reducers'
export const isIOS = () => {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
};
export default (store) => ({
  onEnter: (nextState, replace) => {
    if (isIOS() && !nextState.location.state) {
      const raw = sessionStorage.getItem("paymentData");
 
      if (raw) {
        replace({
          pathname: nextState.location.pathname,
          state: JSON.parse(raw)
        });
      }
    }
  },
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const PaymentScreenView = require('./containers/PaymentScreenContainer').default
      const reducer = require('../../../modules/app').default
 
      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, { key: 'app', reducer })
 
      /*  Return getComponent   */
      cb(null, PaymentScreenView)
 
    /* Webpack named bundle   */
    }, 'Application')
  }
})
 


// WEBPACK FOOTER //
// ./src/routes/Home/routes/Payment/PaymentScreen/index.js